<template>
  <div class="pretreatment">
    <p class="xPadding titleModal">
      {{ $t(`technicalFile.network.steam.step1.title`) }}
    </p>
    <v-row class="xPadding">
      <v-col
        cols="12"
        class="yPadding"
      >
        <VSelect
          v-model="data.filtration"
          :label="$t('technicalFile.network.steam.step1.filtration')"
          :items="displayedUnits('yesOrno')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          hideDetails
          data-cy="filtration"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        cols="12"
        class="yPadding"
      >
        <VSelect
          v-model="data.ionExchangeSofteners"
          :label="$t('technicalFile.network.steam.step1.ionExchangeSofteners')"
          :items="displayedUnits('yesOrno')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          hideDetails
          data-cy="ionExchangeSofteners"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        cols="12"
        class="yPadding"
      >
        <VSelect
          v-model="data.dealkalizers"
          :label="$t('technicalFile.network.steam.step1.dealkalizers')"
          :items="displayedUnits('yesOrno')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          hideDetails
          data-cy="dealkalizers"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        cols="12"
        class="yPadding"
      >
        <VSelect
          v-model="data.reverseOsmosis"
          :label="$t('technicalFile.network.steam.step1.reverseOsmosis')"
          :items="displayedUnits('yesOrno')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          hideDetails
          data-cy="reverseOsmosis"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        cols="12"
        class="yPadding"
      >
        <VSelect
          v-model="data.demineralizer"
          :label="$t('technicalFile.network.steam.step1.demineralizer')"
          :items="displayedUnits('yesOrno')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          hideDetails
          data-cy="demineralizer"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        cols="12"
        class="yPadding"
      >
        <VSelect
          v-model="data.edx"
          :label="$t('technicalFile.network.steam.step1.edx')"
          :items="displayedUnits('yesOrno')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          hideDetails
          data-cy="edx"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        cols="12"
        class="yPadding"
      >
        <VSelect
          v-model="data.deaerator"
          :label="$t('technicalFile.network.steam.step1.deaerator')"
          :items="displayedUnits('yesOrno')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          hideDetails
          data-cy="deaerator"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        cols="12"
        class="yPadding"
      >
        <VSelect
          v-model="data.hotwell"
          :label="$t('technicalFile.network.steam.step1.hotwell')"
          :items="displayedUnits('yesOrno')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          hideDetails
          data-cy="hotwell"
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';

export default {
    name: 'Pretreatment',
    props: {
        pretreatment: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {},
        };
    },
    computed: {
        ...mapGetters([
            'units',
        ]),
    },
    watch: {
        pretreatment: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.pretreatment) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { pretreatment: this.data });
        },
        displayedUnits(type) {
            return this.units && this.units[type] ? this.units[type] : [];
        },
        isOtherOption(field) {
            return this.data[field] === -1;
        },
    },
};
</script>
<style lang="scss" scoped>
.xPadding{
  padding: 0 6rem;
}
.yPadding {
    padding-bottom: 5px;
    padding-top: 5px;
    padding-right: 0;
    padding-left: 10px;
}
.pretreatment {
    padding: 0 6rem;
}
@media screen and (max-width: 600px) {
   .xPadding{
      padding: 0;
    }
}
</style>
